import React from 'react';

import { useAppContext } from '../../contexts/AppContext';
import useServerSideRendering from '../../hooks/useServerSideRendering';
import useWindowSize from '../../hooks/useWindowSize';
import { subscribe_path } from '../../routes';
import { getImgxSrc } from '../../utils/images';
import Button from '../BaseUI/Button';

const HeaderSection = ({ isSubscriber }: { isSubscriber: boolean }) => {
  const { width: windowWidth } = useWindowSize();
  const { env } = useAppContext();
  const hydrated = useServerSideRendering();

  return (
    <div className="mt-20 sm:-mt-20 justify-center mx-auto flex lg:justify-end border-solid border-0 border-b border-gray-300">
      <div className="lg:w-10/12 lg:flex-row sm:!px-24 !px-16 md:w-full sm:flex-col-reverse flex justify-between flex-wrap lg:!px-0">
        <div className="sm:mt-24 lg:mt-64 pb-48 sm:pb-64 lg:w-7/12 md:w-full pr-24">
          <div className="font-serif font-medium text-headline-lg md:text-headline-xl text-pro-red ">
            Read The Information first...
            <span className="text-black block">
              {' '}
              or <span className="italic">them</span> later
            </span>
          </div>
          <div className="mt-8 mb-24 font-serif text-style font-normal body-lg text-[#545B69] lg:max-w-[520px]">
            The Information journalists get the news that other newsrooms envy. That’s why our
            exclusive deals, product launches and strategic moves were followed by the New York
            Times, Bloomberg, the Wall Street Journal and dozens of other outlets more than 400
            times in the last year.
          </div>
          <div className="text-headline-sm font-serif font-bold">
            Get the news straight from the source.
          </div>
          {!isSubscriber && (
            <Button
              className="mt-8 w-[240px] !capitalize text-sans !text-body-lg"
              rounded="slight"
              type="button"
              variant="primary"
              href={subscribe_path()}
            >
              Subscribe
            </Button>
          )}
        </div>
        {hydrated &&
          (windowWidth > 1200 ? (
            <div className="flex-shrink-0 lg:w-5/12">
              <img
                className="h-full w-full object-cover"
                src={getImgxSrc({
                  path: 'brand_campaign/heroDesktop.png',
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="Hero Image"
              />
            </div>
          ) : (
            <div className="flex-shrink-0 w-full">
              <img
                className="hidden sm:flex max-w-lg sm:max-w-full sm:w-full"
                src={getImgxSrc({
                  path: 'brand_campaign/heroMidsize.png',
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="Hero Image"
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default HeaderSection;
